var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('headline',[_vm._v(_vm._s(_vm.$t('login-history.title')))]),_c('login-history-table',{attrs:{"load":_vm.load,"with-channel":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }